module.exports = __webpack_public_path__ + "static/media/swimmer.40cb0319.svg";